webpackJsonp([107818501498521],{

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _fiore = __webpack_require__(120);
	
	var _fiore2 = _interopRequireDefault(_fiore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Bio = function (_React$Component) {
	  _inherits(Bio, _React$Component);
	
	  function Bio() {
	    _classCallCheck(this, Bio);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Bio.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'card' },
	      _react2.default.createElement(
	        'div',
	        { className: 'card-content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'media' },
	          _react2.default.createElement(
	            'div',
	            { className: 'media-left' },
	            _react2.default.createElement(
	              'figure',
	              { className: 'image is-48x48' },
	              _react2.default.createElement('img', {
	                src: _fiore2.default,
	                alt: 'Fiore Basile'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'media-content' },
	            _react2.default.createElement(
	              'p',
	              { className: 'title is-4' },
	              'Fiore Basile'
	            ),
	            'Creative, coder, digital fabrication expert and instructor living in Pisa, Italy and around the globe.',
	            ' ',
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/about' },
	              'More about me'
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Bio;
	}(_react2.default.Component);
	
	exports.default = Bio;
	module.exports = exports['default'];

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/fiore.b40c8a33.jpg";

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(49);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(23);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Bio = __webpack_require__(73);
	
	var _Bio2 = _interopRequireDefault(_Bio);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogPostTemplate = function (_React$Component) {
	  _inherits(BlogPostTemplate, _React$Component);
	
	  function BlogPostTemplate() {
	    _classCallCheck(this, BlogPostTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogPostTemplate.prototype.render = function render() {
	    var post = this.props.data.markdownRemark;
	    var siteTitle = (0, _get2.default)(this.props, 'data.site.siteMetadata.title');
	
	    return _react2.default.createElement(
	      'section',
	      { className: 'section is-medium' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_reactHelmet2.default, { title: post.frontmatter.title + ' | ' + siteTitle }),
	        _react2.default.createElement(
	          'h1',
	          { className: 'title is-1' },
	          post.frontmatter.title
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'subtitle is-3' },
	          post.frontmatter.date
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tags' },
	          post.frontmatter.tags.map(function (tag) {
	            return _react2.default.createElement(
	              'span',
	              { className: 'tag', key: tag },
	              tag
	            );
	          })
	        ),
	        _react2.default.createElement('div', { className: 'content', dangerouslySetInnerHTML: { __html: post.html } }),
	        _react2.default.createElement('hr', null),
	        _react2.default.createElement(_Bio2.default, null)
	      )
	    );
	  };
	
	  return BlogPostTemplate;
	}(_react2.default.Component);
	
	exports.default = BlogPostTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-c54d037bbedab5c33516.js